import React, { useState } from 'react';
import { 
  Filter1, 
  Image, 
  VideoLibrary,
  Fingerprint
} from '@mui/icons-material';
import './HelpCenter.css';
import L1HELP from './L1HELP';
import L2Images from './L2Images';
import L2Videos from './L2Videos';

const HelpCenter = () => {
  const [activeSection, setActiveSection] = useState('l1');

  const sections = {
    l1: {
      title: 'L1',
      icon: <Filter1 />,
      component: <L1HELP />
    },
    l2images: {
      title: 'L2 - Images', 
      icon: <Image />,
      component: <L2Images />
    },
    l2videos: {
      title: 'L2 Videos',
      icon: <VideoLibrary />,
      component: <L2Videos />
    }
  };

  const sectionList = Object.entries(sections).map(([id, section]) => ({ id, ...section }));

  return (
    <div className="help-center">
      <div className="help-center__container">
        {/* Sidebar Navigation */}
        <aside className="help-center__sidebar">
          <div className="help-center__header">
            <h2 className="help-center__title">Help Center</h2>
            <p className="help-center__subtitle">Guidelines and documentation</p>
          </div>
          
          <nav className="help-center__nav">
            {sectionList.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`help-center__nav-item ${
                  activeSection === section.id ? 'help-center__nav-item--active' : ''
                }`}
              >
                <div className="help-center__nav-icon">{section.icon}</div>
                <span className="help-center__nav-title">{section.title}</span>
                {activeSection === section.id && (
                  <div className="help-center__nav-indicator" />
                )}
              </button>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="help-center__main">
          <div className="help-center__headings">
            <Fingerprint />
            <h1>{sections[activeSection]?.title || 'Guidelines'}</h1>
          </div>
          
          <div className="help-center__content">
            {sections[activeSection]?.component || (
              <div className="help-center__empty">
                <p>Select a category from the sidebar to view guidelines.</p>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default HelpCenter;